<svelte:options tag="instagram-feed" />

<script>
	import { onMount } from "svelte";
	export let apikey = "";
	export let username = "";
	export let limit = 10;
	export let skip = 0;
	export let id = "";
	let promise;

	async function getMedia() {
		const res = await fetch(
			`https://us-central1-instagram-feed-api.cloudfunctions.net/api/media/${username}?limit=${limit}&skip=${skip}&key=${apikey}&id=${id}`
		);
		const json = await res.json();

		if (res.ok) {
			return json.data;
		} else {
			throw new Error(json.message);
		}
	}

	onMount(async () => {
		promise = getMedia();
	});
</script>

<div class="media-feed-wrapper">
	{#if apikey.length < 1 || username.length < 1}
		{#if apikey.length < 1}
			<p class="instagram-feed__warning">
				Missing API key, can't load anything. Please visit
				<a target="_new" href="https://instagram-feed-api.web.app/"
					>Instagram Feed API</a
				>
				if you need to sign up for one.
			</p>
		{/if}
		{#if username.length < 1}
			<p class="instagram-feed__warning">
				Missing `username`. What would you like us to show?
			</p>
		{/if}
	{:else}
		{#await promise}
			<p class="instagram-feed__loader">...loading</p>
		{:then response}
			{#each response || [] as photo}
				{#if photo.media_type === "IMAGE" || photo.media_type === "CAROUSEL_ALBUM"}
					<div class="instagram-feed__item-wrapper grid-column">
						<a
							href={photo.permalink}
							target="_ignew"
							class="instagram-feed__item-image-wrapper"
						>
							<div class="instagram-feed__item-image-container">
								<img
									class="instagram-feed__item-image"
									src={photo.media_url}
									alt={photo.caption}
								/>
							</div></a
						>
						<figure class="instagram-feed__item-caption">
							{photo.caption}
						</figure>
					</div>
				{:else if photo.media_type === "VIDEO"}
					<div class="instagram-feed__item-wrapper grid-column">
						<a
							href={photo.permalink}
							target="_ignew"
							class="instagram-feed__item-image-wrapper"
						>
							<div class="instagram-feed__item-image-container">
								<img
									class="instagram-feed__item-image"
									src={photo.thumbnail_url}
									alt={photo.caption}
								/>
							</div>
						</a>
						<figure class="instagram-feed__item-caption">
							{photo.caption}
						</figure>
					</div>
				{/if}
			{:else}No media found{/each}
		{:catch error}
			<figure class="instagram-feed__error">{error}</figure>
		{/await}
	{/if}
</div>

<style>
	.media-feed-wrapper {
		--direction: column;
		--columns: 1fr;
		--rows: 1fr;
	}

	.instagram-feed__item-wrapper {
		display: grid;
		grid-template-columns: var(--columns);
		grid-template-rows: var(--rows);
	}

	.instagram-feed__item-image-wrapper {
		margin: 0;
	}

	.instagram-feed__item-image-container {
		height: 0;
		padding-bottom: 100%;
		position: relative;
		width: 100%;
	}

	.instagram-feed__item-image {
		bottom: 0;
		height: 100%;
		left: 0;
		margin: 0 auto;
		object-fit: cover;
		position: absolute;
		right: 0;
		top: 0;
	}

	.instagram-feed__item-image::after {
		content: "";
		display: block;
		padding-bottom: 100%;
	}
	.instagram-feed__item-caption {
		margin: 0;
		padding: 1em;
	}

	@media screen and (min-width: 991px) {
		.media-feed-wrapper {
			--direction: row;
			--columns: 1fr 1fr;
			--rows: 1fr;
		}
	}
</style>
